import React, { useState, useEffect } from 'react';
import {
  EuiLoadingSpinner,
  EuiPanel,
  EuiTextColor,
  EuiBasicTable,
} from '@elastic/eui';
import { convertEpochToDate } from '../../utils';
import { renderCreatorIdentityServicePrinciple } from '../../utils/JsxUtils';
import { useSdpdsReadOnlyOperation } from '../../hooks/useSdpdsReadOnlyOperation';

const columns = [
  {
    field: 'property',
    name: 'property',
  },
  {
    field: 'value',
    name: 'value',
    render: (item) => {
      if (typeof item === 'function') return item();
      return item;
    },
  },
];

export const StackDetails = (props) => {
  const [isRequestActive, setIsRequestActive] = useState(true);
  const [exception, setException] = useState(null);
  const [items, setItems] = useState([]);

  const { stackName } = props;

  const { data, error } = useSdpdsReadOnlyOperation({
    operation_name: 'DescribeStack',
    payload: {
      name: stackName,
    }
  });

  const updateResponse = (stackData) => {
    const newItems = [];
    const {
      auditProperties: {
        createdBy,
        creationTime,
        lastModificationTime,
        lastModifiedBy,
      },
      name,
      serviceName,
      configuration: { role_arn },
      stackSettings: {
        maxConcurrentNodesPercent,
        availabilityThreshold,
        maxConcurrentDomains,
        maxFailedDeployment,
      },
    } = stackData;

    newItems.push({ property: 'Stack Name', value: name });
    newItems.push({
      property: 'Created By',
      value: renderCreatorIdentityServicePrinciple(createdBy),
    });
    newItems.push({
      property: 'Creation Time',
      value: convertEpochToDate(creationTime),
    });
    newItems.push({ property: 'Role ARN', value: role_arn });
    newItems.push({ property: 'Last Modified By', value: lastModifiedBy });
    newItems.push({
      property: 'Last Modified Time',
      value: convertEpochToDate(lastModificationTime),
    });
    newItems.push({ property: 'Service Name', value: serviceName });
    newItems.push({
      property: 'Availability Threshold',
      value: availabilityThreshold,
    });
    newItems.push({
      property: 'Max Concurrent Domains',
      value: maxConcurrentDomains,
    });
    newItems.push({
      property: 'Max Concurrent Nodes Percent',
      value: maxConcurrentNodesPercent,
    });
    newItems.push({
      property: 'Max Failed Deployment',
      value: maxFailedDeployment,
    });

    setItems(newItems);
  };

  useEffect(() => {
    if (error) {
      setException(error.message || error);
      setIsRequestActive(false);
    } else if (data?.sdpdsReadOnlyOperation?.stack) {
      updateResponse(data.sdpdsReadOnlyOperation.stack);
      setIsRequestActive(false);
    }
  }, [data, error]);

  useEffect(() => {
    if (data?.sdpdsReadOnlyOperation?.stack) {
      updateResponse(data.sdpdsReadOnlyOperation.stack);
      setIsRequestActive(false);
    } else if (error) {
      setException(error.message || error);
      setIsRequestActive(false);
    } else {
      setItems([]);
      setIsRequestActive(true);
      setException(null);
    }
  }, [stackName]);

  if (isRequestActive) {
    return <EuiLoadingSpinner size="l" id="loadingSpinner" />;
  } else if (exception) {
    return (
      <EuiPanel>
        <EuiTextColor color={'danger'}>{exception}</EuiTextColor>
      </EuiPanel>
    );
  }
  return <EuiBasicTable columns={columns} items={items} />;
};
